import React, { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import {
  getCurrencyCodes,
  getGatewayTypes,
  serverErrorHandler,
} from '../../Shared/utils/helper';
import Master from '../Layouts/Master';
import Behpardakht from './Gateway/Behpardakht';
import Bitpay from './Gateway/Bitpay';
import Sadad from './Gateway/Sadad';
import Sep from './Gateway/Sep';

const validationSchema = Yup.object({
  type: Yup.number()
    .typeError('نوع پرداخت الزامی است')
    .required('نوع پرداخت الزامی است'),
  currency_code: Yup.string().required('واحد پولی الزامی است'),
  status: Yup.number()
    .typeError('انتخاب وضعیت الزامی است')
    .required('انتخاب وضعیت الزامی است'),
});

const Gateway = () => {
  const context = useContext(EventContext);
  const { search } = useLocation();
  const [serverErrors, setServerErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [formSubmitLoading, setSubmitFormLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [removeId, setRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [type, setType] = useState(undefined);
  const [defaultLoading, setDefaultLoading] = useState(false);

  useEffect(() => {
    // getSetting();
    getShippingRates();
  }, [search]);

  const getSetting = async (loading = false) => {
    setLoading(true);
    await useApi.get(
      '/setting',
      (res) => {
        const { data } = res;
        context.setting = data;
        if (loading) {
          setLoading(false);
        }
      },
      (err) => {
        setLoading(false);
        error('خطا در دیافت اطلاعات از سرور');
      },
    );
  };

  const getShippingRates = async () => {
    setLoading(true);
    await useApi.get(
      '/gateway',
      {},
      (res) => {
        context.gatwayes = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('خطا در دیافت اطلاعات از سرور');
      },
    );
  };

  const handleSubmit = async (values) => {
    values['config'] = Object.fromEntries(
      Object.entries(values).filter(
        ([key]) =>
          key !== 'type' && key !== 'status' && key !== 'currency_code',
      ),
    );
    setSubmitFormLoading(true);
    await useApi.post(
      '/gateway',
      values,
      (res) => {
        success('هزینه حمل با موفقیت ذخیره شد');
        setSubmitFormLoading(false);
        getShippingRates();
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
          setSubmitFormLoading(false);
        } else {
          error(`تنظیمات به علت خطا ذخیره نشد`);
          setSubmitFormLoading(false);
        }
        setSubmitFormLoading(false);
      },
    );
  };

  const removeData = async (data, removeType) => {
    setRemoveLoading(true);
    let url = `/gateway/${data?.id}`;

    await useApi.delete(
      url,
      {},
      (res) => {
        success('حذف با موفقیت انجام شد.');
        setModalIsOpen(false);
        getShippingRates();
        setRemoveLoading(false);
        setRemoveId({});
      },
      (err) => {
        setModalIsOpen(false);
        setRemoveLoading(false);
        error('حذف به علت خطا انجام نشد لطفا مجددا تلاش کنید');
      },
    );
  };

  const setDefault = async (id) => {
    setDefaultLoading(true);
    let url = `/gateway/set-default-gateway/${id}`;
    await useApi.post(
      url,
      {},
      (res) => {
        success('روش پرداخت با موفقیت پیشفرض شد');
        setDefaultLoading(false);
        getShippingRates();
      },
      (err) => {
        setDefaultLoading(false);
        error('خطا در پیشفرض کردن روش پرداخت');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست روش های پرداخت
          </h1>
        </div>
      </div>
      <div className='px-6 bg-slate-300 dark:bg-dark-800 pt-8 rounded-tr-3xl min-h-screen py-3'>
        <Formik
          initialValues={{
            type: '',
            currency_code: '',
            status: 1,
          }}
          onSubmit={(values, { setSubmitting }) => {
            handleSubmit(values, setSubmitting);
          }}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='col-12 col-md-6'>
                  <div className='form-group'>
                    <label className='form-label'>نوع پرداخت</label>
                    <select
                      value={values?.type}
                      onChange={handleChange}
                      className='form-control'
                      name='type'
                    >
                      <option value=''>انتخاب کنید</option>
                      {getGatewayTypes.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage
                      error={
                        serverErrors?.type ? serverErrors?.type : errors.type
                      }
                    />
                  </div>
                </div>

                <div className='col-12 col-md-6'>
                  <div className='form-group'>
                    <label className='form-label'>واحد پولی</label>
                    <select
                      name='currency_code'
                      value={values?.currency_code}
                      onChange={handleChange}
                      className='form-control'
                    >
                      <option value=''>انتخاب کنید</option>
                      {getCurrencyCodes.map((currency) => (
                        <option key={currency.value} value={currency.value}>
                          {currency.label}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage
                      error={
                        serverErrors?.currency_code
                          ? serverErrors?.currency_code
                          : errors.currency_code
                      }
                    />
                  </div>
                </div>
                {values?.type == 1 && (
                  <Behpardakht
                    serverErrors={serverErrors}
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                  />
                )}
                {values?.type == 2 && (
                  <Sadad
                    serverErrors={serverErrors}
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                  />
                )}
                {values?.type == 3 && (
                  <Bitpay
                    serverErrors={serverErrors}
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                  />
                )}
                {values?.type == 4 && (
                  <Sep
                    serverErrors={serverErrors}
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                  />
                )}
                <div className='col-12 col-md-6'>
                  <div className='form-group'>
                    <label className='form-label'>وضعیت</label>
                    <select
                      name='status'
                      value={values?.status}
                      onChange={handleChange}
                      className='form-control'
                    >
                      = <option value='1'>فعال</option>
                      <option value='0'>غیرفعال</option>
                    </select>
                    <ErrorMessage
                      error={
                        serverErrors?.status
                          ? serverErrors?.status
                          : errors.status
                      }
                    />
                  </div>
                </div>
                <div className='col-12 col-md-6'>
                  <div className='form-group mt-4'>
                    <button className='btn btn-info mt-1' type='submit'>
                      ثبت
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>

        <div className='w-100 overflow-auto'>
          {context.gatwayes?.data?.length > 0 ? (
            <table className='table table-hover'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>نوع</th>
                  <th>واحد پول</th>
                  <th>وضعیت</th>
                  <th>پیشفرض</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {context.gatwayes?.data?.map((item) => (
                  <tr key={item.id}>
                    <th>{item.id}</th>
                    <td>{item.type_name}</td>
                    <td>{item.currency_code_name}</td>
                    <td>{item.status_name}</td>
                    <td>
                      {item.default == 1 ? (
                        <i className='fad fa-check text-success f-16'></i>
                      ) : (
                        <div className='d-flex flex-row align-items-center'>
                          <i className='fad fa-times text-danger f-16'></i>
                          {defaultLoading ? (
                            <button
                              className='btn btn-sm btn-success mx-3'
                              type='button'
                              disabled
                              style={{ cursor: 'not-allowed' }}
                            >
                              <div
                                className='spinner-border spinner-border-sm text-success mb-1'
                                role='status'
                              ></div>{' '}
                            </button>
                          ) : (
                            <button
                              className='btn btn-sm btn-success mx-3'
                              type='button'
                              onClick={() => setDefault(item?.id)}
                            >
                              پیشفرض کردن
                            </button>
                          )}
                        </div>
                      )}
                    </td>

                    <td>
                      <div className='d-flex flex-row'>
                        <Link
                          className='mx-2'
                          to='#'
                          onClick={(e) => {
                            e.preventDefault();
                            setRemoveId(item);
                            setModalIsOpen(true);
                          }}
                        >
                          حذف
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
              <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
              <span className='f-13 font-weight-bold text-secondary'>
                روش پرداختی یافت نشد
              </span>
            </div>
          )}
        </div>
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف روش پرداخت مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeData(removeId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default Gateway;
